








import { Component, Vue } from 'vue-property-decorator';
import TitleBar from '@/components/layout/TitleBar.vue';

@Component({
  components: {
    TitleBar
  },
})
export default class Home extends Vue {
  private created() {
    console.log('The app is created!');
  }

  private mounted() {
    /*
    this.$http.get(`i18n/es`).then(response => {
      const msgs = response.data;
    }).catch((e) => {
      console.error(e)
    })

     */
  }
}
